<div *ngIf="!isLoading">
  <div class="AcdView">
    <div id="Title" class="AcdTopTitle">
      <div>
        <div class="heading2">
          Change Request #{{ crNo }} Detail
          <span class="statusTag" *ngIf="statusFlag">({{ statusFlag }})</span>
        </div>
        <div class="acdviewlink" *ngIf="showLink()">
          <a
            id="link1"
            href="#/ACD/EditRequest?CR={{ crNo }}&buildType=JobPlan&step=Search"
            [ngClass]="isUserCanAccessRequest || specialist ? 'links' : 'disabledLink'"
          >
            Go to Search
          </a>
          <span class="padding-xs">|</span>

          <a
            id="link2"
            href="#/ACD/EditRequest?CR={{ crNo }}&buildType=MWO&step=Build"
            class="links"
          >
            MWO Build&nbsp;
          </a>
          <span class="padding-xs">|</span>

          <a
            id="link3"
            href="#/ACD/EditRequest?CR={{ crNo }}&buildType=JobPlan&step=Build"
            class="links"
          >
            <span>Job Plan Build&nbsp;</span>
          </a>
          <span class="padding-xs">|</span>

          <a
            id="link4"
            href="#/ACD/EditRequest?CR={{ crNo }}&buildType=PM&step=Build"
            class="links"
          >
            PM Build&nbsp;
          </a>
          <span class="padding-xs">|</span>

          <a
            id="link5"
            href="#/ACD/EditRequest?CR={{ crNo }}&buildType=EPL&step=Build"
            class="links"
            >EPL Build&nbsp;
          </a>
        </div>
      </div>
    </div>
    <div id="Actions" class="content-top-actions ph">
      <input
        type="submit"
        name="GenerateFiles"
        value="Generate Load Files"
        id="GenerateFiles"
        class="ExportButton"
        *ngIf="specialist"
        (click)="generateLoadFiles()"
      />
      <input
        (click)="closeRequestClick()"
        type="submit"
        name="CloseACD"
        value="Close Request"
        id="CloseACD"
        class="ExportButton"
        *ngIf="!(['completed','cancelled'].includes(statusFlag.toLowerCase())) && specialist"
      /><span id="Space"><span class="Text_Note"></span></span>
      <input
        onclick=""
        type="submit"
        name="Cancel"
        value="Cancel Request"
        id="Cancel"
        class="ExportButton"
        [disabled]="isBtn3Disabled()"
        [ngClass]="isUserCanAccessRequest || specialist ? '' : 'disabledLink'"
        *ngIf="isStatusCompleted()"
        (click)="cancelRequestClick()"
      /><span id="Space"><span class="Text_Note"></span></span>
    </div>
  </div>
  <div>
    <div id="nonStyleGrid">
      <kendo-grid
        [scrollable]="'none'"
        [kendoGridBinding]="acdviewrequestTable"
      >
        <kendo-grid-column
          field="id"
          [width]="100"
          title="Request #"
        ></kendo-grid-column>
        <kendo-grid-column
          field="requestor"
          title="Requested By"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column
          field="onBehalfOf"
          title="On Behalf Of"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column field="status" title="Status" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="!isStatusBuild() || ['completed', 'cancelled', 'build'].includes(dataItem.status.toLowerCase()); else showStatusDropdown">
              <div>{{ dataItem.status.toLowerCase() }}</div>
            </ng-container>
            <ng-template #showStatusDropdown>
              <kendo-dropdownlist [value]="statusFlag"
                                  [data]="newStatusList"
                                  (valueChange)="changeStatus($event)">
              </kendo-dropdownlist>
            </ng-template>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="assignedTo"
          title="Assigned To"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column
          field="facility"
          title="Facility"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column field="priority" title="Priority" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="!isStatusBuild() || ['completed', 'cancelled', 'build'].includes(dataItem.status.toLowerCase()); else showPriorityDropdown">
              <div>{{ dataItem.priority }}</div>
            </ng-container>
            <ng-template #showPriorityDropdown>
              <kendo-dropdownlist [value]="selectedPriorityItem"
                                  [data]="newPrioirtyList"
                                  (valueChange)="changePriority($event)">
              </kendo-dropdownlist>
            </ng-template>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="createdDate"
          title="Created date"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="wordbreak">{{ dataItem.createdDateTime | date : "dd-MM-yyyy HH:mm:ss" }}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="submitDate"
          [hidden]="hideSubmitDate"
          title="Submission date"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div>{{ dataItem.submissionDateTime | date : "dd-MM-yyyy HH:mm:ss" }}</div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          [hidden]="hideSubmitDate"
          field="dueDate"
          title="Target Date"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="dueDate">
              {{ dataItem.dueDateTime | date : "dd-MM-yyyy HH:mm:ss" }}
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div> 
    <div class="c-row">
      <div class="c-col-6">
        <div class="c-row">
          <div class="c-col-3">Description</div>
          <div class="c-col-9">{{ Description }}</div>
        </div>
        <div class="c-row">
          <div class="c-col-3">Justification</div>
          <div class="c-col-9 Value"><pre>{{Justification}}</pre></div>
        </div>
      </div>
      <div class="c-col-4">
        <div class="c-row">
          <div class="c-col-3">Attachments</div>
          <div class="c-col-9">
            <div *ngFor="let attachment of crAttachmentDetails">
              <a *ngIf="attachment.fileName != null"
                 (click)="downloadAttachment(attachment?.blobURI || '',attachment.id)">
                <ul class="commentsLink"
                    style="text-transform: none !important">
                  <fa-icon [icon]="downloadIcon" class="closeIcon"></fa-icon>
                  {{attachment.fileName}}
                </ul>
              </a>
            </div>
            <span *ngIf="crAttachmentDetails.length == 0">No attachments added to this request's header...</span>
          </div>
        </div>
      </div>
    </div>
    <div class="separtor"></div>     
   
    <div class="summaryBlock">
      <div id="nonStyleGrid" class="acdSummary">
        <h4 class="heading2">ACD Summary</h4>
        <kendo-grid [scrollable]="'none'" [kendoGridBinding]="acdsummarydata">
          <kendo-grid-column field="label" [width]="100" title="Label">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span (click)="navigateToBuilds(dataItem.id)" class="buildType">
                <u class="primaryBlue">{{ dataItem.label }}</u>
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="totalAdd"
            title="Count Of Add"
            [width]="100"
          ></kendo-grid-column>
          <kendo-grid-column
            field="totalChange"
            title="Count Of Change"
            [width]="100"
          ></kendo-grid-column>
          <kendo-grid-column
            field="totalDelete"
            title="Count Of Delete"
            [width]="100"
          ></kendo-grid-column>
          <kendo-grid-column
            field="totalNoChange"
            title="Count Of No-Change"
            [width]="100"
          ></kendo-grid-column>
           <ng-template kendoGridNoRecordsTemplate>
      <div >No items to show...</div>
    </ng-template>
        </kendo-grid>
      </div>
    </div>

    <div id="nonStyleGrid" >
      <h4 class="heading2">Comments History</h4>
      <kendo-grid
        [kendoGridBinding]="commentsHistory"
        [navigable]="true"
        [scrollable]="'none'"
        id="commentsHistoryViewAcd"
      >
        <kendo-grid-column
          field="type"
          [width]="100"
          title="Type"
        ></kendo-grid-column>
        <kendo-grid-column
          field="status"
          title="Status"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column
          field="comment"
          title="Note"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column field="submittedDateTime" title="Date" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem.submittedDateTime | awsDateTransform}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          field="changedBy"
          title="User"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column
          field="filenametext"
          title="Attachments"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <!-- <a
              *ngIf="dataItem.filenametext != null"
              (click)="downloadAttachment(dataItem.filenametext)"
              ><u class="commentsLink" style="text-transform: none !important;">{{ dataItem.filenametext | fileNameTransform }}</u></a
            > -->
            @if (dataItem.filenametext != null){
            <a
              *ngFor="let file of dataItem.files"
              (click)="downloadAttachment(file.blobUri,file.attachmentId,true)"
              ><u class="commentsLink"
                  style="text-transform: none !important">
                  <fa-icon [icon]="downloadIcon" class="closeIcon"></fa-icon>
                  {{ file.displayName }}
                </u>
              <br></a
            >
          } @else {
            <p *ngIf="dataItem.filenametext == null" class="NoItems">
              No items to show...
            </p>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="50">
          <ng-template kendoGridHeaderTemplate let-dataItem>
            <div class="w-100 align-center">
              <button class="btn4" (click)="openPopup(addBtn)" #addBtn>
                Add
              </button>
            </div>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-center">  
              <button
              *ngIf="dataItem.changeRequestCommentId"
              class="btn4"
              (click)="onEditCLick(dataItem.changeRequestCommentId)"
            >
              Edit
            </button>
            </div>
            
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>
<!-- <div class="loaderContainer" *ngIf="isLoading">
    <kendo-loader *ngIf="isLoading" type="infinite-spinner" size="large" themeColor="primary" class="primaryBlue">
    </kendo-loader>
</div> -->

<!-- kendo popup for add request -->

<kendo-popup [animate]="true" *ngIf="showpopup" (clickOutside)="closePopup()">
  <div class="popupDialog">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle">Add Comment</span>
      <div href="#" class="popupClose" role="button" tabindex="0"></div>
    </div>
    <div>
      <kendo-loader
        *ngIf="isPopupLoading"
        [size]="'medium'"
        [type]="'infinite-spinner'"
        class="popupLoader"
      ></kendo-loader>
      <div class="popupContent" *ngIf="!isPopupLoading">
        <kendo-textarea
          placeholder="Comment  "
          class="popupText"
          [ngClass]="popuperror ? 'errorClass' : ''"
          (valueChange)="onCommentValueChange($event)"
        ></kendo-textarea>

        <kendo-formerror class="errorList" *ngIf="popuperror"
          >Required field</kendo-formerror
        >
        <span style="margin-right: 10px; font-size: 14px">Attachments</span>
        <app-file-upload-popup
          class="fileUpload"
          [elementId]="'AcdFile-upload'"
          [labelCSS]="'displayNone'"
          [mainButtonCSS]="'popupfile'"
          [displayBtn]="true"
          (fileUploaded)="saveAttachment($event)"
          [multipleAllowed]="true"
        >
        </app-file-upload-popup>
        <kendo-grid
          [data]="fileAttachmentDetails"
          *ngIf="fileAttachmentDetails.length > 0"
          [scrollable]="'none'"
          id="PopupfileAttachmentGrid"
        >
          <kendo-grid-column title="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div (click)="deleteFileAttachment(dataItem)">
                <fa-icon [icon]="closeIcon" class="closeIcon"></fa-icon>
              </div>
            </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="FileName" field="fileName">
            </kendo-grid-column> -->
          <kendo-grid-column title="FileName" field="fileName">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span style="text-transform: none !important">{{
                dataItem.fileName | fileNameTransform
              }}</span>
            </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="filesize" field="fileSize">
            </kendo-grid-column> -->
          <kendo-grid-column title="filesize" field="fileSize">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.fileSize | fileSizeTransform }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <!-- <input type="file" class="file-input" (change)="addFiles($event)" #fileUpload>
         <div class="file-upload">
          {{fileName || "No file uploaded yet."}}     
           <button material-icons color="primary" class="upload-btn"
             (click)="fileUpload.click()">
             <span class="material-symbols-outlined">attach_file</span>
           </button>
       </div> -->
        <div class="submitComment margintopxl">
          <button type="submit" class="button-secondary" (click)="addComment()">
            Submit
          </button>
          <button
            type="submit"
            class="button-secondary cancel"
            (click)="closePopup()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</kendo-popup>

<!-- kendo popup for edit request -->

<kendo-popup
  [animate]="true"
  *ngIf="showeditpopup"
  (clickOutside)="closePopup()"
>
  <div class="popupDialog">
    <div class="popupHeader">
      <span class="popupTitle" id="popupTitle">Edit Comment</span>
      <div href="#" class="popupClose" role="button" tabindex="0"></div>
    </div>
    <div>
      <div class="popupContent">
        <kendo-textarea
          placeholder="Comment"
          [value]="newCommentValue"
          (valueChange)="onCommentValueChange($event)"
        ></kendo-textarea>
        <kendo-formerror class="errorList" *ngIf="popuperror"
          >Required field</kendo-formerror
        >
        <span class="poupAttachmentText">Attachments</span>
        <app-file-upload-popup
          class="fileUpload"
          [elementId]="'AcdFile-upload'"
          [labelCSS]="'displayNone'"
          [mainButtonCSS]="'popupfile'"
          [displayBtn]="true"
          (fileUploaded)="saveAttachment($event)"
          [multipleAllowed]="true"
        >
        </app-file-upload-popup>
        <kendo-grid
          [data]="fileAttachmentDetails"
          *ngIf="fileAttachmentDetails.length > 0"
          [scrollable]="'none'"
          id="PopupfileAttachmentGrid"
        >
          <kendo-grid-column title="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div (click)="removeFileDetails(dataItem)">
                <fa-icon [icon]="closeIcon" class="closeIcon"></fa-icon>
              </div>
            </ng-template>
          </kendo-grid-column>
          <!-- <kendo-grid-column title="FileName" field="fileName">
            </kendo-grid-column>
            <kendo-grid-column title="filesize" field="fileSize">
            </kendo-grid-column> -->
          <kendo-grid-column title="FileName" field="fileName">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span style="text-transform: none !important">{{
                dataItem.fileName | fileNameTransform
              }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="filesize" field="fileSize">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.fileSize | fileSizeTransform }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div class="submitComment margintopxl">
          <button
            type="submit"
            class="button-secondary"
            (click)="editComment()"
          >
            Submit
          </button>
          <button
            type="submit"
            class="button-secondary cancel"
            (click)="closePopup()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</kendo-popup>

<!-- kendo popup for close request -->

<kendo-popup
  [animate]="true"
  *ngIf="showclosepopup"
  (clickOutside)="closePopup()"
>
  <div class="popupDialogCloseCancel">
    <div class="popupHeader">
      <span class="popupTitleclose" id="popupTitle">Close Request</span>
      <div href="#" class="popupCloseCancel" role="button" tabindex="0"></div>
    </div>
    <div>
      <div class="popupContent">
        <kendo-textarea
          placeholder="Closure Comments"
          [ngClass]="popuperror ? 'errorClass' : ''"
          class="poupTextarea"
          (valueChange)="onCommentValueChange($event)"
        ></kendo-textarea>
        <kendo-formerror class="errorList" *ngIf="popuperror"
          >Required field</kendo-formerror
        >
        <span style="margin-right: 10px">Attachments</span>
        <app-file-upload-popup
          class="fileUpload"
          [elementId]="'AcdFile-upload'"
          [labelCSS]="'displayNone'"
          [mainButtonCSS]="'popupfile'"
          [displayBtn]="true"
          (fileUploaded)="saveAttachment($event)"
          [multipleAllowed]="true"
        >
        </app-file-upload-popup>
        <kendo-grid
          [data]="fileAttachmentDetails"
          *ngIf="fileAttachmentDetails.length > 0"
          [scrollable]="'none'"
          id="PopupfileAttachmentGrid"
        >
          <kendo-grid-column title="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div (click)="deleteFileAttachment(dataItem)">
                <fa-icon [icon]="closeIcon" class="closeIcon"></fa-icon>
              </div>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="FileName" field="fileName">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span style="text-transform: none !important">{{
                dataItem.fileName | fileNameTransform
              }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="filesize" field="fileSize">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.fileSize | fileSizeTransform }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div class="submitComment margintopxl">
          <button
            type="submit"
            class="button-secondary"
            (click)="submitClosePopup()"
          >
            Submit
          </button>
          <button
            type="submit"
            class="button-secondary cancel"
            (click)="closePopup()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</kendo-popup>

<!-- kendo popup for cancel request -->

<kendo-popup
  [animate]="true"
  *ngIf="showcancelpopup"
  (clickOutside)="closePopup()"
>
  <div class="popupDialogCloseCancel">
    <div class="popupHeader">
      <span class="popupTitleclose" id="popupTitle">Cancel Request</span>
      <div href="#" class="popupTitleclose" role="button" tabindex="0"></div>
    </div>
    <div>
      <div class="popupContent">
        <kendo-textarea
          placeholder="Closure Comments"
          [ngClass]="popuperror ? 'errorClass' : ''"
          class="poupTextarea"
          (valueChange)="onCommentValueChange($event)"
        ></kendo-textarea>
        <kendo-formerror class="errorList" *ngIf="popuperror"
          >Required field</kendo-formerror
        >

        <app-file-upload-popup
          class="fileUpload"
          [elementId]="'AcdFile-upload'"
          [labelCSS]="'displayNone'"
          [mainButtonCSS]="'popupfile'"
          [displayBtn]="true"
          (fileUploaded)="saveAttachment($event)"
          [multipleAllowed]="true"
        >
        </app-file-upload-popup>
        <kendo-grid
          [data]="fileAttachmentDetails"
          *ngIf="fileAttachmentDetails.length > 0"
          [scrollable]="'none'"
          id="PopupfileAttachmentGrid"
        >
          <kendo-grid-column title="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div (click)="deleteFileAttachment(dataItem)">
                <fa-icon [icon]="closeIcon" class="closeIcon"></fa-icon>
              </div>
            </ng-template>
          </kendo-grid-column>
          <!--  <kendo-grid-column title="FileName" field="fileName">
            </kendo-grid-column>
            <kendo-grid-column title="filesize" field="fileSize">
            </kendo-grid-column> -->
          <kendo-grid-column title="FileName" field="fileName">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span style="text-transform: none !important">{{
                dataItem.fileName | fileNameTransform
              }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="filesize" field="fileSize">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.fileSize | fileSizeTransform }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <div class="submitComment margintopxl">
          <button
            type="submit"
            class="button-secondary btncolor"
            (click)="submitCancelPopup()"
          >
            Submit
          </button>
          <button
            type="submit"
            class="button-secondary cancel"
            (click)="closePopup()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</kendo-popup>

<app-content-popup
  *ngIf="popupShow"
  [dialogTitle]="popupTitle"
  [width]="popupWidth"
  [height]="popupHeight"
  (closeContentPopUp)="closeActionPopup($event)"
>
  <ng-container>
    <app-obselute-items-popup
      [setCRNo]="crNo"
      (closeContentPopUp)="closeActionPopup($event)"
    ></app-obselute-items-popup>
  </ng-container>
</app-content-popup>
